import styled from "@emotion/styled";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

import IconNewsletter from "./newsletter.svg";

export const Container = styled(ResponsiveContainer)`
  inline-size: 24px;
  block-size: 24px;
`;

export const StyledIconNewsletter = styled(IconNewsletter)`
  inline-size: 100%;
  block-size: 100%;
`;
